import React, { useReducer } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { FormRow, FormCol } from 'style/styled'
import { CashRegisters, filterReducer, DatePeriod } from '../filterFragments'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import { CardsRow, CardCol } from '../filterFragments/styled'
import { DateTimePicker, Select, Checkbox } from 'components/forms'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { listProducts } from 'sections/product/gql/query'
import FilterCardRemote from 'components/FilterCard/FilterCardRemote'
import { listCashRegisters } from 'gql/query'
import { useQuery } from 'components/graphql'
import ProfileSettings from 'components/ProfileSettings/ProfileSettings'
import { Row, Col } from 'react-flexbox-grid'

const Filter = ({ handleSetFilter }) => {
	const [t] = useTranslation()
	const { data } = useQuery(listCashRegisters, { fetchPolicy: 'cache-first' })

	const defaultFilter = {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),

		timeStart: moment().utc().startOf('day').format('HH:mm:ss.SSSZ'),
		timeEnd: moment().utc().endOf('day').format('HH:mm:ss.SSSZ'),

		cashRegisterIds: data?.listCashRegisters?.map(({ id }) => id) || [],
		productIds: [],
		interval: 60,
		isCreditCustomer: false,
		groupBy: 0
	}
	const [filterPrepare, dispatchFilter] = useReducer(filterReducer, defaultFilter)

	const { from, to, timeStart, timeEnd, cashRegisterIds, productIds, interval, groupBy, isCreditCustomer } = filterPrepare
	const isDatePeriod = moment(to).diff(moment(from), 'days') >= 1
	const dateLabel = t('statistic_section.strings.date')

	const handleSetProfileSettings = settings => {
		const filterToSet = settings ? settings : defaultFilter
		dispatchFilter({
			type: 'hydrateFromSaved',
			value: filterToSet
		})
	}

	return (
		<ContentBlock blockId='0' startExpanded={!!'called'} label={t('common.strings.settings')}>
			<Row>
				<Col xs={12} style={{ marginLeft: -20 }}>
					<ProfileSettings filters={filterPrepare} onUpdateFilters={handleSetProfileSettings} nameLocalStorage={'dayStatisticsProfiles'} />
				</Col>
			</Row>
			<FormRow>
				<FormCol narrow={!isDatePeriod}>
					<DatePeriod
						value={{ fromDateTime: from, toDateTime: to }}
						onChange={value => dispatchFilter({ value, type: 'dateTime' })}
						label={dateLabel}
						labelPeriod={{
							from: `${dateLabel} ${t('common.strings.from').toLowerCase()}`,
							to: `${dateLabel} ${t('common.strings.to').toLowerCase()}`
						}}
					/>
					<Checkbox
						checked={isCreditCustomer}
						onChange={e => dispatchFilter({ value: e.target.checked, type: 'isCreditCustomer' })}
						label={t('common.strings.credit_customer')}
					/>
				</FormCol>
				<FormCol xs>
					<Select
						value={interval}
						onChange={({ value }) => dispatchFilter({ value, type: 'interval' })}
						label={t('common.fields.time')}
						options={[
							{ value: 60, label: t('common.dates.minute_count', { count: 60 }) },
							{ value: 30, label: t('common.dates.minute_count', { count: 30 }) },
							{ value: 15, label: t('common.dates.minute_count', { count: 15 }) },
							{ value: 5, label: t('common.dates.minute_count', { count: 5 }) }
						]}
						noForm
					/>
					<Select
						value={JSON.stringify(groupBy)}
						label={t('statistic_section.strings.grouped_by')}
						onChange={({ value }) => dispatchFilter({ type: 'groupBy', value })}
						options={[
							{ label: `${t('common.strings.product')}-${t('common.fields.time')}`, value: 0 },
							{ label: `${t('common.fields.time')}-${t('common.strings.product')}`, value: 1 },
							{ label: `${t('common.strings.product')}-${t('common.strings.branch')}`, value: 2 },
							{ label: `${t('common.strings.branch')}-${t('common.strings.product')}`, value: 3 },
							{ label: `${t('common.fields.total_price')}`, value: 4 },
							{ label: `${t('common.strings.branch')}-${t('common.fields.total_price')}`, value: 5 },
							{ label: `${t('common.fields.total_price')}-${t('common.strings.branch')}`, value: 6 }
						]}
						noForm


					/>
				</FormCol>
				<FormCol xs>
					<DateTimePicker
						noForm
						value={{ from: timeStart, to: timeEnd }}
						onChange={value => dispatchFilter({ value, type: 'timePeriod' })}
						picker='time'
						interval
						label={{ from: t('common.strings.from'), to: t('common.strings.to') }}
						addDateToTime={false}
					/>
				</FormCol>
			</FormRow>
			<ExpandableBlocks nested>
				<ContentBlock startExpanded label={t('common.buttons.filter')}>
					<CardsRow>
						<CardCol>
							<CashRegisters
								value={cashRegisterIds}
								onChange={value => dispatchFilter({ value, type: 'cashRegisterIds' })}
							/>
						</CardCol>
						<CardCol>
							<FilterCardRemote
								listQuery={listProducts}
								label={t('common.strings.product')}
								allItemsLabel={t('common.strings.all_products')}
								value={productIds}
								onChange={value => dispatchFilter({ value, type: 'productIds' })}
								withSearch={true}
							/>
						</CardCol>
					</CardsRow>
				</ContentBlock>
			</ExpandableBlocks>
			<Divider />
			<Col type='row'>
				<Button text={t('common.buttons.calculate')} onClick={() => handleSetFilter(filterPrepare)}/>
			</Col>
		</ContentBlock>
	)
}

export default Filter
